export default function StatCard({ title, value, icon, color = "bg-blue-100", textColor = "text-blue-700", subtitle }) {
  return (
    <div className={`flex items-center gap-3 sm:gap-4 p-2 sm:p-4 rounded-xl shadow-sm bg-white transition-all`}>
      <div className={`w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center rounded-lg ${color}`}>
        <span className={`text-xl sm:text-2xl ${textColor}`}>{icon}</span>
      </div>
      <div>
        <div className="text-gray-500 text-xs sm:text-xs">{title}</div>
        {subtitle && <div className="text-gray-400 text-[10px] sm:text-xs leading-tight">{subtitle}</div>}
        <div className="text-lg sm:text-2xl font-bold">{value}</div>
      </div>
    </div>
  );
}
